var _g, _g2, _line, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9994 23C15.3484 22.9969 12.8068 21.9528 10.9322 20.0969C9.05764 18.2409 8.00322 15.7246 8.00006 13.0999C8.00006 12.8082 8.11694 12.5284 8.32529 12.3222C8.53363 12.1159 8.81635 12 9.11099 12C9.40563 12 9.68811 12.1159 9.89646 12.3222C10.1048 12.5284 10.2219 12.8082 10.2219 13.0999C10.2219 15.1421 11.0414 17.1008 12.5 18.5449C13.9586 19.9889 15.9367 20.8002 17.9994 20.8002C20.0622 20.8002 22.0406 19.9889 23.4991 18.5449C24.9577 17.1008 25.7772 15.1421 25.7772 13.0999C25.7772 12.8082 25.8941 12.5284 26.1024 12.3222C26.3108 12.1159 26.5935 12 26.8881 12C27.1828 12 27.4653 12.1159 27.6736 12.3222C27.882 12.5284 27.9991 12.8082 27.9991 13.0999C27.9962 15.7247 26.9416 18.2412 25.0669 20.0972C23.1923 21.9532 20.6506 22.9971 17.9994 23V23Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0006 18C16.5423 17.9984 15.144 17.4052 14.1128 16.3506C13.0816 15.296 12.5015 13.8661 12.4999 12.3746V5.62439C12.4902 4.87939 12.6253 4.13981 12.8973 3.44862C13.1693 2.75743 13.5729 2.12839 14.0846 1.59802C14.5963 1.06766 15.206 0.646552 15.8781 0.359121C16.5503 0.0716907 17.2714 -0.0763416 17.9999 -0.0763416C18.7284 -0.0763416 19.4497 0.0716907 20.1219 0.359121C20.794 0.646552 21.4037 1.06766 21.9154 1.59802C22.4271 2.12839 22.8307 2.75743 23.1027 3.44862C23.3747 4.13981 23.5098 4.87939 23.5001 5.62439V12.3746C23.4985 13.8659 22.9187 15.2957 21.8877 16.3503C20.8567 17.4048 19.4588 17.9981 18.0006 18V18ZM18.0006 2.24974C17.1256 2.25054 16.2867 2.60629 15.6679 3.23895C15.0491 3.87162 14.7008 4.72954 14.6997 5.62439V12.3746C14.6997 13.2698 15.0475 14.1282 15.6664 14.7612C16.2853 15.3941 17.1246 15.7498 17.9999 15.7498C18.8752 15.7498 19.7147 15.3941 20.3336 14.7612C20.9525 14.1282 21.3003 13.2698 21.3003 12.3746V5.62439C21.2992 4.72972 20.9512 3.87196 20.3326 3.23932C19.714 2.60669 18.8754 2.25081 18.0006 2.24974V2.24974Z",
    fill: "#00FFE6"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 22,
    x2: 18.5,
    y2: 25,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 11,
    fill: "white",
    transform: "translate(8 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 18,
    fill: "white",
    transform: "translate(12.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMicrophone);
export default __webpack_public_path__ + "static/media/ico-microphone.c89deff6.svg";
export { ForwardRef as ReactComponent };